module.exports = new __parcel__URL__("temple.263692a0.jpg").toString();